module.exports = __webpack_public_path__ + "img/logo.0229df09.png";